<template>
	<el-form>
		<el-form-item>
			<el-input
				v-model="post.mobile"
				prefix-icon="el-icon-user"
				placeholder="请填写手机号"
				@keyup.enter.native="register"
			></el-input>
		</el-form-item>
		<el-form-item>
			<el-input
				v-model="post.smscode"
				prefix-icon="el-icon-chat-dot-square"
				placeholder="短信验证吗"
				@keyup.enter.native="register"
			></el-input>
			<span class="btn-send-sms">
				<Sms :mobile="post.mobile"></Sms>
			</span>
		</el-form-item>
		<el-form-item>
			<el-input
				v-model="post.password"
				prefix-icon="el-icon-lock"
				placeholder="登录密码"
				show-password
				@keyup.enter.native="register"
			></el-input>
		</el-form-item>
		<el-form-item class="el-form-action">
			<el-button type="primary" @click.prevent="register" :loading="loading">立即注册</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import Sms from "@/components/Sms";

export default {
	name: "Register",
	components: { Sms },
	data() {
		return {
			loading: false,
			post: {
				mobile: "",
				password: "",
				smscode: ""
			}
		};
	},
	methods: {
		register(e) {
			this.$message.closeAll();

			var patrn = /^(1|01)\d{10}$/;
			if (!this.post.mobile) {
				return this.$message.error("请填写手机号码");
			}
			if (!patrn.test(this.post.mobile) && this.post.mobile != "") {
				return this.$message.error("请正确填写手机号码");
			}
			if (!this.post.smscode) {
				return this.$message.error("请填写短信验证码");
			}
			if (!this.post.password) {
				return this.$message.error("请填写登录密码");
			}

			this.loading = true;
			this.post.username = this.post.mobile;
			this.axios
				.post(this.axios.apiGateway + "user/register", this.post)
				.then(res => {
					if (res.data.errcode) {
						this.$message.error(res.data.errmsg);
					} else {
						this.$notify({
							title: "恭喜您，注册成功！",
							message: "您的会员账号是：" + res.data.nickname + "",
							type: "success"
						});

						this.$store.dispatch("login", res.data);
						this.$parent.hide && this.$parent.hide();
					}
					this.loading = false;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Passport/Register.vue